import createInstance from "./Instance.mjs";
const renderMsg = (config) => createInstance(config);
export {
  renderMsg as default
};
